// extracted by mini-css-extract-plugin
module.exports = {"text":"styles_text__iOK3Z"};